abstract class Path {
	static parse(rawPath: Path.TPathRaw) : Path.TPath {
		const path: Path.IPathNode[] = [];

		let idx = 0;
		let ascendantCount = 0;

		while (idx < rawPath.length && rawPath[idx] === '@') {
			ascendantCount++;
			idx += 1;
		}

		const isRelative = ascendantCount > 0;

		let startIdx = idx;
		let currentLocation: 'inner' | 'outer' = 'outer';

		while (idx < rawPath.length) {
			if (rawPath[idx] === '.') {
				if (startIdx < idx) {
					path.push({
						id: rawPath.slice(startIdx, idx),
						location: currentLocation
					});
				}
				currentLocation = 'outer';
				startIdx = idx + 1;
			} else if (rawPath[idx] === ':') {
				if (startIdx < idx) {
					path.push({
						id: rawPath.slice(startIdx, idx),
						location: currentLocation
					});
				}
				currentLocation = 'inner';
				startIdx = idx + 1;
			}

			idx++;
		}

		if (startIdx < idx) {
			path.push({
				id: rawPath.slice(startIdx, idx),
				location: currentLocation
			});
		}

		if (isRelative) {
			return new Path.RelativePath(path, ascendantCount - 1);
		}

		return new Path.AbsolutePath(path);
	};

	readonly abstract type : string;
	readonly path : Path.IPathNode[];

	/**
	 * Create a relative path from the current starting at startIndex.
	 */
	slice(startIndex : number) {
		return new Path.RelativePath(
			this.path.slice(startIndex),
			0
		);
	};

	isEqualTo(RHS : Path) {
		const LHS = this;
		if (LHS.type !== RHS.type) {
			return false;
		}
		if (LHS.path.length !== RHS.path.length) {
			return false;
		}
		return LHS.path.every((LHS_x, xi) => {
			const RHS_x = <Path.IPathNode>RHS.path[ xi ];
			return (
				(LHS_x.location !== RHS_x.location) ? false : (
					(RHS_x.id === '**') ? true : (LHS_x.id === RHS_x.id)
				)
			);
		});
	}

	constructor(path : Path.IPathNode[]) {
		this.path = path;
	};
};
namespace Path {
	export interface IPathNode {
		id : Component.TId;
		location : 'inner' | 'outer';
	};

	export class AbsolutePath extends Path {
		override readonly type = 'absolute';
	};

	export class RelativePath extends Path {
		override readonly type = 'relative';
		readonly ascendsCount : number;

		constructor(path : Path.IPathNode[], ascendsCount : number) {
			super(path);
			this.ascendsCount = ascendsCount;
		};
	};
	export type TPath = AbsolutePath | RelativePath;
	export type TPathRaw = string;

}
export default Path;
import Component from './Component';
